const VIEW_TYPE_VIEW_CRQ_WITH_TICKS_AND_ERRORS = 'view-crq-with-ticks-and-errors';
const VIEW_TYPE_VIEW_CRQ_STANDARD = 'standard';

const TAB_SECTION_SUMMARY = 'TAB_SECTION_SUMMARY';
const TAB_APPROVALS_HISTORY = 'TAB_APPROVALS_HISTORY';
const TAB_COMPLETION_REVIEW = 'TAB_COMPLETION_REVIEW';
const TAB_COMMS_SUMMARY = 'TAB_COMMS_SUMMARY';


export {
  VIEW_TYPE_VIEW_CRQ_WITH_TICKS_AND_ERRORS,
  VIEW_TYPE_VIEW_CRQ_STANDARD,
  TAB_SECTION_SUMMARY,
  TAB_APPROVALS_HISTORY,
  TAB_COMPLETION_REVIEW,
  TAB_COMMS_SUMMARY,
};
